(() => {
  const sticky = document.querySelector('[data-tm-sticky]');
  const start = document.getElementById('gOp6KjuYuZ');
  const stop = document.getElementById('gGEXfxIr7Q');
  if (!sticky || !start || !stop) return;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    sticky.classList.toggle('is-visible', start.getBoundingClientRect().top < 0 && stop.getBoundingClientRect().top > innerHeight);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  update();
})();
